import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => (
  {
    container: {
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: theme.palette.white.efesBackgroundLight,
      marginBottom: '1rem',
      marginTop: '1rem',
      border: '1px solid #EE5F37',
      borderRadius: 16,
      minHeight: 160,
      position: 'relative',
      paddingTop: '3rem',
      [theme.breakpoints.down('sm')]: {
        paddingTop: '4rem',
      },
    },
    specialPriceBackground: {
      position: 'absolute',
      top: '-14px',
    },
    specialPrice: {
      position: 'absolute',
      top: 0,
      fontSize: 18,
      color: theme.palette.white.main,
      textTransform: 'uppercase',
      fontWeight: 500,
    },
    umbrella: {
      width: 44,
      height: 44,
      margin: 5,
      [theme.breakpoints.down('sm')]: {
        width: 30,
        height: 30,
        margin: 10,
      },
    },
    gridItem: {
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    selectContainer: {
      border: `1px solid ${theme.palette.gray.efesGrayAlt}`,
      minWidth: 250,
      height: 80,
      borderRadius: 12,
      backgroundColor: theme.palette.white.main,
      display: 'flex',
      justifyContent: 'space-evenly',
      alignItems: 'center',
      '&:hover': {
        backgroundColor: theme.palette.primary.main,
        cursor: 'pointer',
        color: theme.palette.white.main,
        '& $amount': {
          color: theme.palette.white.main,
        },
        border: 'none',
      },
      [theme.breakpoints.down('sm')]: {
        minWidth: 270,
      },
    },
    amount: {
      color: theme.palette.primary.main,
      fontWeight: 700,
      fontSize: 16,
    },
    label: {
      fontSize: 16,
      marginBottom: 8,
      fontWeight: 500,
    },
    left: {
      paddingTop: 10,
    },
    active: {
      backgroundColor: theme.palette.primary.main,
      cursor: 'pointer',
      color: theme.palette.white.main,
      '& $amount': {
        color: theme.palette.white.main,
      },
      border: 'none',
      '&:hover': {
        [theme.breakpoints.up('lg')]: {
          backgroundColor: theme.palette.primary.hover,
        },
      },
    },
    todayIcon: {
      width: 24,
      height: 24,
    },
    closeButton: {
      position: 'absolute',
      right: 10,
      top: 10,
      color: theme.palette.black.main,
    },
    icon: {
      width: 20,
      height: 20,
    },
    insuranceCoveragePrice: {
      display: 'flex',
      gap: 10,
      fontSize: 16,
      padding: '2rem  0',
      [theme.breakpoints.down('sm')]: {
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
      },
    },
  }
));

export default useStyles;
